// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"727":"3c66cada","811":"7bf9c81b","864":"85f03db7"}[chunkId] + ".js";
};